import i18next from 'i18next';

export const mapSurveyUsage = (usage, propertyUsageOther) => {
    switch (usage) {
        case 1:
            return i18next.t('survey.usageOffice');
        case 2:
            return i18next.t('survey.usageProductionIndustrial');
        case 3:
            return i18next.t('survey.usageHousing');
        case 4:
            return i18next.t('survey.usageWarehouseOrLogistics');
        case 5:
            return i18next.t('survey.usageShopping');
        case 6:
            return i18next.t('survey.usageSports');
        case 7:
            return propertyUsageOther;
        default:
            return i18next.t('survey.undefined');
    }
};

export const mapClassification = (classification) => {
    switch (classification) {
        case 0:
            return i18next.t('survey.undefined');
        case 1:
            return i18next.t('survey.classificationOda1');
        case 2:
            return i18next.t('survey.classificationOda2');
        case 3:
            return i18next.t('survey.classificationOda3');
        default:
            return i18next.t('survey.undefined');
    }
};

export const mapFilterClass = (filterClass) => {
    switch (filterClass) {
        case 1:
            return 'ePM1';
        case 2:
            return 'ePM2,5';
        case 3:
            return 'ePM10';
        case 4:
            return 'Coarse';
        default:
            return i18next.t('survey.undefined');
    }
};

export const mapFilterType = (filterType) => {
    switch (filterType) {
        case 1:
            return i18next.t('survey.filterTypeBag');
        case 2:
            return i18next.t('survey.filterTypeCartridge');
        case 3:
            return i18next.t('survey.filterTypeOther');
        case 4:
            return i18next.t('survey.filterTypeCassetteFilter');
        default:
            return i18next.t('survey.undefined');
    }
};

export const mapHeatRecoveryModel = (heatRecoveryModel) => {
    switch (heatRecoveryModel) {
        case 0:
            return i18next.t('survey.heatRecoveryNone');
        case 1:
            return i18next.t('survey.heatRecoveryRotating');
        case 2:
            return i18next.t('survey.heatRecoveryCoil');
        case 3:
            return i18next.t('survey.heatRecoveryCounterflow');
        case 4:
            return i18next.t('survey.heatRecoveryRotaryWithRecirculation');
        case 5:
            return i18next.t('survey.heatRecoveryCoilWithRecirculation');
        default:
            return i18next.t('survey.undefined');
    }
};

export const mapMachineType = (machineType) => {
    switch (machineType) {
        case 1:
            return i18next.t('survey.machineTypeSupply');
        case 2:
            return i18next.t('survey.machineTypeExhaust');
        default:
            return i18next.t('survey.undefined');
    }
};
